import { isCustomInputEveryoneCanEdit, isDatatypeEditableForEveryone, isDocumentEveryoneCanEdit } from "."
import { Document, UserProfile } from "../../models"
import { CustomInputMapping, UserCollectionsState } from "../../redux"
import { doesUserHavePermissionOnGroupItem, isUserAdminOnGroupItem, isUserItemAuthor, isUserMemberOnItem, isUserOrgAdmin, isUserOrgViewer } from "./userPermissionsOnItemHelpers"

export type Rule = 'userOrgViewer' | 'customInputAndEveryoneCanEdit' | 'editableTypesForEveryone' | 'everyoneCanEditDocument' | 'userOrgAdmin' | 'userItemAuthor' | 'userMemberOnItem' | 'userAdminOnGroupItem' | 'userHavePermissionOnGroupItem'

export const editableTypesForEveryone = ["contact", "company"]
export const definedRules: Rule[] = ['customInputAndEveryoneCanEdit', 'editableTypesForEveryone', 'everyoneCanEditDocument', 'userOrgAdmin', 'userItemAuthor', 'userMemberOnItem', 'userAdminOnGroupItem', 'userHavePermissionOnGroupItem']

type ArgumentTypes<F extends Function> = F extends (...args: infer A) => any ? A : never;
type ExecuterArgs = ArgumentTypes<typeof isUserOrgViewer> | ArgumentTypes<typeof isCustomInputEveryoneCanEdit> | ArgumentTypes<typeof isDatatypeEditableForEveryone> | ArgumentTypes<typeof isDocumentEveryoneCanEdit> | ArgumentTypes<typeof isUserOrgAdmin> | ArgumentTypes<typeof isUserItemAuthor> | ArgumentTypes<typeof isUserMemberOnItem> | ArgumentTypes<typeof isUserAdminOnGroupItem> | ArgumentTypes<typeof doesUserHavePermissionOnGroupItem>

export const factoryExecuter = (rule: Rule): (...args: ExecuterArgs) => boolean => {
    switch (rule) {
        case 'userOrgViewer':
            return (...args) => isUserOrgViewer(...args as ArgumentTypes<typeof isUserOrgViewer>)
        case 'customInputAndEveryoneCanEdit':
            return (...args) => isCustomInputEveryoneCanEdit(...args as ArgumentTypes<typeof isCustomInputEveryoneCanEdit>)
        case 'editableTypesForEveryone':
            return (...args) => isDatatypeEditableForEveryone(...args as ArgumentTypes<typeof isDatatypeEditableForEveryone>)
        case 'everyoneCanEditDocument':
            return (...args) => isDocumentEveryoneCanEdit(...args as ArgumentTypes<typeof isDocumentEveryoneCanEdit>)
        case 'userOrgAdmin':
            return (...args) => isUserOrgAdmin(...args as ArgumentTypes<typeof isUserOrgAdmin>)
        case 'userItemAuthor':
            return (...args) => isUserItemAuthor(...args as ArgumentTypes<typeof isUserItemAuthor>)
        case 'userMemberOnItem':
            return (...args) => isUserMemberOnItem(...args as ArgumentTypes<typeof isUserMemberOnItem>)
        case 'userAdminOnGroupItem':
            return (...args) => isUserAdminOnGroupItem(...args as ArgumentTypes<typeof isUserAdminOnGroupItem>)
        case 'userHavePermissionOnGroupItem':
            return (...args) => doesUserHavePermissionOnGroupItem(...args as ArgumentTypes<typeof doesUserHavePermissionOnGroupItem>)
    }
}

export const factoryArgs = (
    user: UserProfile,
    collections: UserCollectionsState,
    document: Document,
    customInputMapping: CustomInputMapping | undefined
) => (rule: Rule): ExecuterArgs => {
    switch (rule) {
        case 'userOrgViewer':
            return [user] as ArgumentTypes<typeof isUserOrgViewer>
        case 'customInputAndEveryoneCanEdit':
            return [customInputMapping] as ArgumentTypes<typeof isCustomInputEveryoneCanEdit>
        case 'editableTypesForEveryone':
            return [document.dataType, editableTypesForEveryone] as ArgumentTypes<typeof isDatatypeEditableForEveryone>
        case 'everyoneCanEditDocument':
            return [document] as ArgumentTypes<typeof isDocumentEveryoneCanEdit>
        case 'userOrgAdmin':
            return [user] as ArgumentTypes<typeof isUserOrgAdmin>
        case 'userItemAuthor':
            return [document, user.auth0_id] as ArgumentTypes<typeof isUserItemAuthor>
        case 'userMemberOnItem':
            return [document, user.auth0_id] as ArgumentTypes<typeof isUserMemberOnItem>
        case 'userAdminOnGroupItem':
            return [document, user, collections] as ArgumentTypes<typeof isUserAdminOnGroupItem>
        case 'userHavePermissionOnGroupItem':
            return [document, collections] as ArgumentTypes<typeof doesUserHavePermissionOnGroupItem>
    }
}